module.exports = __webpack_public_path__ + "img/S620.855d96da.jpg";